import { createSlice } from '@reduxjs/toolkit'
import { auth } from 'providers/firebaseAuth'
import { get } from 'utils/lodash'

const initialState = {
  // uid: the Firebase user this selection was made under; auth is shared across tabs.
  selectedLoginDetails: { show: false, businessName: '', businessId: '', uid: '' },
  allBusinesses: [],
}

const loginPersistSlice = createSlice({
  name: 'LoginPersist',
  initialState,
  reducers: {
    setSelectedLoginDetails: {
      reducer: (state, action) => {
        state.selectedLoginDetails = { ...state.selectedLoginDetails, ...action.payload }
      },
      // Stamped here so no dispatch site has to remember to.
      prepare: payload => ({ payload: { ...payload, uid: auth?.currentUser?.uid ?? '' } }),
    },
    setAllBusinesses: (state, action) => {
      state.allBusinesses = action.payload
    },
    resetLogin: state => {
      state.selectedLoginDetails = { ...initialState.selectedLoginDetails }
      state.allBusinesses = [...initialState.allBusinesses]
    },
  },
})

export const { setSelectedLoginDetails, setAllBusinesses, resetLogin } = loginPersistSlice.actions

export const selectSelectedBusinessId = state => get(state, 'LoginPersist.selectedLoginDetails.businessId', '')

export const selectAllBusinesses = state => get(state, 'LoginPersist.allBusinesses', [])

export default loginPersistSlice.reducer
